module.exports = __webpack_public_path__ + "static/media/NatashaSchmid_Resume_Win20.2684be50.png";